import { VideoFragment } from 'apollo/fragments/types/VideoFragment';
import { SmolVideo } from 'types/pigeon/kmsession';

export function isVideoFragment(video?: SmolVideo | VideoFragment | InsightsEmbedResponse): video is VideoFragment {
  return !!video && (video as Partial<VideoFragment>).__typename === 'Video';
}
